import React from 'react'

import { useFilter } from '../../forms/hocs/filter.context.hoc'
import {
    StyledCheckboxForm,
    StyledRadioElement,
    StyledSearchFilterSelect,
    StyledSearchFilterSelectLabel,
    StyledSearchFilterSelectLabelCount,
    StyledSelectionContainer,
} from '../search-filters-checkbox/search-filters-checkbox.styles'
import { Option } from '../../utils/search/search-results-util/search-results.util'

export const IncludeExcludeOnlyRadioGroup = () => {
    const { filterName, options, onValueChanged = () => {}, selected } = useFilter()

    if (options.length === 1) {
        return null
    }

    const selectedValue = selected.length > 0 ? selected[0] : ''

    const totalCount = options
        .map((x) => x.count || 0)
        .reduce((partialSum, nextValue) => {
            return partialSum + nextValue
        }, 0)

    const optionsWithDefault = [
        {
            value: '',
            label: 'Include',
            count: totalCount,
            description: null,
        },
        ...options,
    ]

    return (
        <StyledCheckboxForm>
            {optionsWithDefault.map(({ label, value, count }: Option) => {
                const valueString = String(value)
                const name = `${filterName}-${valueString.toLowerCase().replace(/\s/g, '_')}`
                return (
                    <StyledSearchFilterSelect
                        as="label"
                        key={`${name}-radio`}
                        data-testid={`${name}-container`}
                        tabIndex={0}
                        htmlFor={`${name}-radio`}
                    >
                        <StyledSearchFilterSelectLabel as="span">{`${label}`}</StyledSearchFilterSelectLabel>
                        <StyledSelectionContainer>
                            {count != null ? (
                                <StyledSearchFilterSelectLabelCount as="span">
                                    {count.toLocaleString()}
                                </StyledSearchFilterSelectLabelCount>
                            ) : null}
                            <StyledRadioElement
                                name={`${filterName}-radio`}
                                id={`${name}-radio`}
                                className={`${name}-radio`}
                                label={''}
                                onChange={(e) => {
                                    e.currentTarget.checked = true
                                    const selected = e.currentTarget.value
                                    onValueChanged([selected])
                                }}
                                value={valueString}
                                checked={valueString === selectedValue}
                                $isWrittenOff={true}
                            />
                        </StyledSelectionContainer>
                    </StyledSearchFilterSelect>
                )
            })}
        </StyledCheckboxForm>
    )
}
